import React, { useState, useEffect, ChangeEvent } from 'react';
import { Input, Button, Row, Col, Form, FormGroup } from 'reactstrap';
import Viewer from 'react-viewer';

function CancelationForm(props: any) {
  const { data, setData, gallery, galleryContainer, isLoading, onAccept, onReject } = props;

  const [hasMotivoRechazo, setHasMotivoRechazo] = useState(false);

  useEffect(() => {
    setHasMotivoRechazo(!!data.motivo_rechazo);
  }, [data.id]);

  const accept = () => {
    if (!onAccept) {
      return;
    }

    onAccept();
  };

  const reject = () => {
    if (!onReject) {
      return;
    }

    onReject();
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { target } = event;

    // Guardamos el nuevo valor
    setData({
      ...data,
      [target.name]: target.value,
    });
  };

  return (
    <Form>
      <Row>
        <Col sm={6}>
          <h6 className="heading text-muted mb-4">
            Matriculado Solicitante
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Matricula</label>
                <p>{ data.matriculate.matricula || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Delegación</label>
                <p>{ data.matriculate.delegacion || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Nombre</label>
                <p>{ data.matriculate.nombre || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Apellido</label>
                <p>{ data.matriculate.apellido || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Es Director</label>
                <p>{ data.es_director ? 'Sí' : 'No' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Director Técnico
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Matricula</label>
                <p>{ data.director_tecnico_ck?.MTR001_N_MATRICULA || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Delegación</label>
                <p>{ data.director_tecnico_ck?.MTR001_ID_DELEGACION || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Nombre</label>
                <p>{ data.director_tecnico_ck?.MTR001_D_NOMBRE || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Apellido</label>
                <p>{ data.director_tecnico_ck?.MTR001_D_APELLIDO || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Consultorio
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Partido</label>
                <p>{ data.partido_name || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Localidad</label>
                <p>{ data.localidad_name || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Calle</label>
                <p>{ data.calle || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Número</label>
                <p>{ data.numero || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Piso</label>
                <p>{ data.piso || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Departamento</label>
                <p>{ data.departamento || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>Código Postal</label>
                <p>{ data.codigo_postal || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Rechazo
          </h6>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>Motivo de rechazo</label>
                {
                  hasMotivoRechazo
                    ?
                      <p>{ data.motivo_rechazo }</p>
                    :
                      <Input
                        id="motivo_rechazo"
                        name="motivo_rechazo"
                        type="textarea"
                        value={data.motivo_rechazo ?? ''}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                }
              </FormGroup>
            </Col>
          </Row>
        </Col>
        <Col sm={6}>
          <div className="">
            <label className="form-control-label">Adjuntos</label>
            <div
              id="gallery-container"
              style={{ height: '80vh' }}
              ref={galleryContainer}
            >
              {
                Array.isArray(gallery) &&
                gallery.length &&
                galleryContainer.current
                  ?
                    <Viewer
                      container={galleryContainer.current}
                      noClose={true}
                      visible={true}
                      disableMouseZoom={true}
                      downloadable={true}
                      disableKeyboardSupport={true}
                      zoomSpeed={0.5}
                      downloadInNewWindow={true}
                      noImgDetails={true}
                      scalable={false}
                      showTotal={false}
                      defaultScale={1.25}
                      defaultImg={{
                        src: require('../../../assets/img/404.png'),
                      }}
                      images={gallery}
                    />
                  : null
              }
            </div>
          </div>
        </Col>
      </Row>
      {
        onAccept || onReject
          ? <Row>
              <hr className="my-4" />
              <Col className="text-center">
                <Button color="danger" onClick={ reject } disabled={ isLoading }>Rechazar</Button>
                <Button color="success" onClick={ accept } disabled={ isLoading }>Aceptar</Button>
              </Col>
            </Row>
          : null
      }
    </Form>
  );
}

export default CancelationForm;
